import React, { useEffect, useRef } from 'react';
import { UnControlled as Codemirror } from 'react-codemirror2';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/xml/xml';
import cn from 'classnames';
import _ from 'lodash';
import {
  preloadMathJaxWithLearnosity,
  setMathJaxTypeset,
} from 'chameleon/src/utility/utils';

const Math = ({ cursor }) => {
  const ref = useRef(null);
  const previewElement = useRef(null);

  useEffect(() => {
    preloadMathJaxWithLearnosity();
  }, []);

  const updatePreview = (newContent) => {
    if (newContent === undefined) {
      return;
    }
    if (previewElement.current) {
      if (_.isString(newContent)) {
        previewElement.current.innerHTML = newContent;
      } else {
        const existing = previewElement.current.firstChild;
        if (existing) {
          previewElement.current.replaceChild(newContent, existing);
        } else {
          previewElement.current.appendChild(newContent);
        }
      }
      setMathJaxTypeset(previewElement.current);
    }
  };

  useEffect(() => {
    if (previewElement.current) {
      const { math } = cursor.value.content;
      updatePreview(math);
    }
  }, [previewElement.current, cursor.value.content.math]);

  const contentCursor = cursor.sub(['content']);
  const { value, requestChange } = contentCursor.sub('math');

  const props = {
    value,
    onChange(editor, data, newValue) {
      if (editor.state.focused) {
        requestChange(newValue);
      }
    },
    options: {
      lineNumbers: true,
      lineWrapping: true,
      mode: 'xml',
    },
    ref,
  };

  return (
    <div>
      <Codemirror {...props} />

      <h3>Preview</h3>
      <div className={cn('preview')} ref={previewElement} />

      <h3>Alt Text</h3>
      <input
        value={contentCursor.sub(['alt']).value}
        onChange={(e) =>
          contentCursor.sub(['alt']).requestChange(e.target.value)
        }
      />
    </div>
  );
};

export default Math;
